import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import { CashHistoryItem } from "@/types/CashHistoryItem";

interface CashHistoryState {
  items: CashHistoryItem[];
  isLoading: boolean;
}

const initialState: CashHistoryState = { items: [], isLoading: false };

export const getCashHistory = createAsyncThunk(
  "cashHistory/getCashHistory",
  async ({ address }: { address: string }) => {
    const response = await axios.get(`${SERVER_URL}/profile/cashHistory/${address}`);
    return response.data;
  }
);

const cashHistorySlice = createSlice({
  name: "cashHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCashHistory.pending, (state) => { state.isLoading = true; })
      .addCase(getCashHistory.fulfilled, (state, { payload }) => { state.items = payload; state.isLoading = false; })
      .addCase(getCashHistory.rejected, (state) => { state.isLoading = false; });
  },
});

export default cashHistorySlice.reducer;
